import { render, staticRenderFns } from "./WaterParameterDetail.vue?vue&type=template&id=20b464c2&"
import script from "./WaterParameterDetail.vue?vue&type=script&lang=js&"
export * from "./WaterParameterDetail.vue?vue&type=script&lang=js&"
import style0 from "./WaterParameterDetail.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports